import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import reducers from './reducers.js';

export default (initialState) => {
  // Redux Configuration
  const middleware = [];
  const enhancers = [];

  // Thunk Middleware
  middleware.push(thunk);

  // Debug logging of Redux actions
  //  By default in a dev build, logging of all Redux actions is
  //  suppressed, since usually you want to just see your own debug
  //
  // Sometimes it’s useful to see user-triggered actions interleaved
  // with your own debug, but the regular automatic refresh actions
  // are unwanted noise. Type the following into the browser console:
  //  window.LOG_ACTIONS = window.LOG_EXCLUDE_NOISE;
  //
  // If you really want to see all the actions, you can do this
  //  window.LOG_ACTIONS = true;
  //
  // And for more complex needs, write your own filtering function
  //
  window.LOG_ACTIONS = false;
  window.LOG_EXCLUDE_NOISE = (getState, action) => {
    switch (action?.type) {
      case 'tokenized/contract/UPDATE_INSTRUMENTS':
        return false;
      default:
        return true;
    }
  };
  const logger = createLogger({
    level: 'info',
    predicate: (getState, action) => {
      if (typeof window.LOG_ACTIONS === 'function') {
        return window.LOG_ACTIONS(getState, action);
      }
      return !!window.LOG_ACTIONS;
    },
    collapsed: true,
  });

  middleware.push(logger);

  // Redux DevTools Configuration
  const actionCreators = {
    // ...counterActions,
  };
  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Options: http://extension.remotedev.io/docs/API/Arguments.html
        actionCreators,
      })
    : compose;

  // Apply Middleware & Compose Enhancers
  enhancers.push(applyMiddleware(...middleware));
  const enhancer = composeEnhancers(...enhancers);

  // Create Store
  const store = createStore(reducers, initialState, enhancer);

  return store;
};
